export const PermissionPayment = {
    PUT: "put-manager-payment-setup-**-PUT",
    POST: "post-manager-payment-setup-POST",
    DELETE: "delete-manager-payment-setup-**-DELETE",
    GET: "get-manager-payment-setup-GET",
    GET_UUID: "get-manager-payment-setup-**-GET"
};